module.exports = __webpack_public_path__ + "images/rounded-edges-meal.png";